import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { tagNameAsyncValidate } from 'libs/validation';

import { ModalTemplate, Button, Loading } from 'components';

import styles from '../../../style/modal.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ModalAlert extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { isClicked, onConfirm, onToggleModal, children, headerTitle } = this.props;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-examAlert-area', 'common-content')}
        visible
        onToggleModal={onToggleModal}
        header={headerTitle}
        buttons={
          <div className={cx('inline-block')}>
            <Button
              buttonColor="#bbbbbb"
              onClick={() => {
                onToggleModal('');
              }}>
              {defineMessages(formatMessage({ id: 'ModalTagAdd_3', defaultMessage: '취소' }))}
            </Button>
            <Button className={cx('gray-button')} disabled={isClicked} onClick={onConfirm}>
              {defineMessages(formatMessage({ id: 'ModalExamDelete_2', defaultMessage: '삭제' }))}
            </Button>
          </div>
        }>
        <div className={cx('modal-content')}>
          <Loading active={isClicked} size="small" content="Waiting..." />
          {children}
        </div>
      </ModalTemplate>
    );
  }
}

ModalAlert.propTypes = {
  onToggleModal: PropTypes.func
};

const mapStateToProps = (state, props) => {
  return {
    initialValues: {
      examNo: props.examNo,
      filter: props.filter
    }
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'formExamAddTag',
    enableReinitialize: true,
    asyncValidate: tagNameAsyncValidate,
    asyncBlurFields: ['tagName'],
    destroyOnUnmount: false,
    touchOnChange: true // validation 안내를 적절한 시점에 보이기 위해 반드시 필요함
  })(injectIntl(ModalAlert))
);



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalAlert.js